// auth types

export const LOGIN = "LOGIN";
export const LOG_OUT = "LOG_OUT";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_LOADING = "RESET_LOADING";
export const SET_LOADING = "SET_LOADING";
export const RESET = "RESET";
export const SET_ERROR = "SET_LOADING";




export const GET_LOGS = "GET_LOGS";


export const SET_NEW_PASSWORD = "SET_NEW_PASSWORD";
export const SEND_ADMIN_LOGIN_OTP = "SEND_ADMIN_LOGIN_OTP";
export const VERIFY_ADMIN_LOGIN_OTP = "VERIFY_ADMIN_LOGIN_OTP";



// admins types
export const GET_ADMIN_USERS = "GET_ADMIN_USERS";
export const GET_ADMIN_USER = "GET_ADMIN_USER";
export const CREATE_ADMIN_USER = "CREATE_ADMIN_USER";
export const EDIT_ADMIN_USER = "EDIT_ADMIN_USER";
export const APPROVE_ADMIN_USER = "APPROVE_ADMIN_USER";


export const CREATE_USER = "CREATE_USER";
export const GET_USERS = "GET_USERS";
export const GET_USER = "GET_USER";
export const EDIT_USER = "EDIT_USER";
export const SYNC_USER = "SYNC_USER";